<div class="backdrop" (click)="onClose()"></div>
<div class="confirmation-box">
  <div class="confirmation-header">
    <p>Confirm Laboratory/Organization</p>
    <em class="material-icons" (click)="onClose()">close</em>
  </div>

  <div class="confirmation-box-content">
      <div style="margin-bottom: 1em">
        <strong>Name: </strong> {{firstAndLastName}}        
        <br>
        <strong>CAP #: </strong> {{capNumber}}
        <br>       
        <strong>Laboratory/Organization: </strong><span>{{orgName}}</span>     
        <span>, {{address}}</span>      
        <span>, {{city}}</span>
        <span>, {{state}}</span>
        <span>, {{postalCode}}</span>
      </div>
  
    <div class="confirmation-box-actions">
      <button class="btn btn-primary" (click)="onConfirm()">Confirm</button>
      <button class="btn" (click)="onClose()" style="color: #009BBF;">Cancel</button>
    </div>
  </div>

</div>